import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.5,10a9.29,9.29,0,0,1-1.27,4.77,9.46,9.46,0,0,1-3.46,3.46A9.29,9.29,0,0,1,10,19.5a9.29,9.29,0,0,1-4.77-1.27,9.46,9.46,0,0,1-3.46-3.46A9.29,9.29,0,0,1,.5,10,9.29,9.29,0,0,1,1.77,5.23,9.46,9.46,0,0,1,5.23,1.77,9.29,9.29,0,0,1,10,.5a9.29,9.29,0,0,1,4.77,1.27,9.46,9.46,0,0,1,3.46,3.46A9.29,9.29,0,0,1,19.5,10Z"
});

var SvgCircle = function SvgCircle(props) {
  return _ref;
};

export default SvgCircle;